var _defs, _rect, _text, _text2, _rect2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductGreenLoans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gOrange",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .card { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); filter: url(#shadow); }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 800; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n      .pill { fill: rgba(255,193,7,0.16); stroke: rgba(255,111,0,0.25); }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1400,
    height: 800
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 80,
    y: 95,
    fontSize: 34
  }, "Green Loans (MSME experience)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 80,
    y: 130,
    fontSize: 16
  }, "Eligibility, terms preview, and submission - powered by the MSME's carbon score and reduction plan.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 80,
    y: 170,
    width: 1240,
    height: 560,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 40,
    rx: 14,
    fill: "rgba(76,175,80,0.10)",
    stroke: "rgba(76,175,80,0.20)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 26,
    fontSize: 14,
    fill: "#2E7D32"
  }, "My Loans"), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 0,
    width: 240,
    height: 40,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 232,
    y: 26,
    fontSize: 14
  }, "Available Banks"), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 0,
    width: 240,
    height: 40,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 482,
    y: 26,
    fontSize: 14
  }, "Loan Calculator"), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 0,
    width: 200,
    height: 40,
    rx: 14,
    fill: "url(#gOrange)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1018,
    y: 26,
    fontSize: 14,
    fill: "#1A202C",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "Apply for loan"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,290)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 16
  }, "Eligibility preview"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 24,
    fontSize: 13
  }, "Instant feedback before MSME submits an application."), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 560,
    height: 360,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(33,150,243,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,74)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Bank"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 512,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 16,
    y: 39,
    fontSize: 14
  }, "ABC Bank v")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,150)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Loan amount"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 246,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 16,
    y: 39,
    fontSize: 14
  }, "\u20B9 5,00,000"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 284,
    y: 0,
    fontSize: 12
  }, "Purpose"), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 10,
    width: 228,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 300,
    y: 39,
    fontSize: 14
  }, "Solar installation v")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,226)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Expected CO\u2082 reduction (kg)"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 246,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 16,
    y: 39,
    fontSize: 14
  }, "1,200"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 284,
    y: 0,
    fontSize: 12
  }, "Payback period (months)"), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 10,
    width: 228,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 300,
    y: 39,
    fontSize: 14
  }, "36")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,304)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 52,
    rx: 14,
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 33,
    fontSize: 14,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Check eligibility")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730,290)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 16
  }, "Eligibility result"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 24,
    fontSize: 13
  }, "Terms are transparent and derived from carbon performance."), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 510,
    height: 360,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(76,175,80,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "pill",
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    rx: 15
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 20,
    fontSize: 12,
    fill: "#7C2D12",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "ELIGIBLE"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 60,
    fontSize: 12
  }, "Eligibility score"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70,
    width: 430,
    height: 10,
    rx: 5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70,
    width: 340,
    height: 10,
    rx: 5,
    fill: "url(#gGreen)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 450,
    y: 82,
    fontSize: 14
  }, "79/100"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,115)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Max loan amount"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 30,
    fontSize: 20
  }, "\u20B9 8,00,000")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,115)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Suggested rate"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 30,
    fontSize: 20
  }, "10.25%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,190)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 0,
    fontSize: 12
  }, "Carbon score discount"), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 30,
    fontSize: 20,
    fill: "#2E7D32"
  }, "1.50%"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 0,
    y: 54,
    fontSize: 13
  }, "Discount improves as MSME's score and savings improve.")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 460,
    height: 52,
    rx: 14,
    fill: "url(#gOrange)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 33,
    fontSize: 14,
    fill: "#1A202C",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "Submit application"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGreenLoans);
export default __webpack_public_path__ + "static/media/product-green-loans.b7336f6b43b0a101a5ddca83dbd3e3a3.svg";
export { ForwardRef as ReactComponent };